export enum fcmActionTypes {
    SET_FCM_TOKEN = 'SET_FCM_TOKEN',
    SET_FCM_SERVICE_WORKER_AVAILABILITY = 'SET_FCM_SERVICE_WORKER_AVAILABILITY',
}
